/* ------------------- IMPORTS */
import styled from '@emotion/styled'
import { Box, Icons } from 'components'
import { AppStore } from 'utils'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */

interface Props {
  action: (e) => void
}

export const BtnGoToProfile = ({ action }: Props) => {
  /* ----------------- STATE  */

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */

  /* ----------------- VARIABLES  */

  /* ----------------- METHODS  */

  /* ----------------- API CALL  */

  /* ----------------- USEEFFECT  */

  return (
    <BtnGoToProfileContainer onClick={action} removeHover>
      <Icons.goToPost />
    </BtnGoToProfileContainer>
  )
}

const BtnGoToProfileContainer = styled(Box)`
  width: 36px;
  height: 36px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${() => AppStore.theme.o.surface};
  border: 1px solid ${() => AppStore.theme.o.black};

  svg {
    width: 24px;
    height: 24px;
    fill: ${() => AppStore.theme.o.black};
  }

  &:hover {
    border-color: transparent;
  }
`
